import ArrowRightIcon from '~/icons/ArrowRight';
import { Badge, Box, Chip, Divider, IconButton, List, ListItem, ListItemSecondaryAction, ListItemText, Stack, Tooltip } from "@mui/material";
import { ListContextProvider, RecordContextProvider, useListContext, useRecordContext } from "ra-core";
import { FC } from "react";
import { Link as RouteLink } from 'react-router-dom'
import useLocalListController from "~/components/list/useLocalListController";
import { RecPatch } from "~/dataProvider/tools";
import { DatabaseResponseDto } from "~/gen/api/encrypt";
import { Pagination as DefaultPagination } from '~/components/list/pagination'
import DatabaseNameField from "~/components/databases/DatabaseNameField";
import { genUrlWithHashid } from "~/utils/hashid";
import { AtopFuncArea, SearchField } from "../list/datagridFunctionWidgets";


const databaseListOptions : {sorters: Record<string, (a:DatabaseResponseDto & RecPatch, b:DatabaseResponseDto & RecPatch) => number>} = {
  sorters: {
    id: (a, b) => a.id < b.id ? -1 : 1,
    name: (a, b) => (a.name || '') < (b.name || '') ? -1 : 1,
  }
}

const DbESCList: FC = () => {
  const listCtrl = useLocalListController({ resource: 'encrypted-dbs', basePath: '' }, databaseListOptions)
  return (
    <ListContextProvider value={listCtrl}>
      <DbListBody />
    </ListContextProvider>
  )
}


const DbListBody: FC = () => {
  const listCtx = useListContext()
  const { data, ids } = listCtx

  return (
    <Box >
      <AtopFuncArea>
        <SearchField 
          sourceKey="dbName"
          match={(d: DatabaseResponseDto, fval:string) => !!d.name && d.name.toLowerCase().includes(fval.trim().toLowerCase())}
          sx={{ width: 280 }}
          TextFieldProps={{ placeholder: 'Search by Database Name' }}
        />
      </AtopFuncArea>
      <Divider sx={{ pb: 0 }} />
      <List
        sx={{
          pt: 0,
          '& div.MuiListItem-root:hover': { bgcolor: theme => theme.palette.action.hover },
          '& div.MuiListItemText-root':{
            '& > span': {display: 'flex'},
            '& div.MuiBox-root': {
              '& div.encryptedDbTip': { top: theme => theme.spacing(-1.5) },
              '& span.encryptedDbTipText': { top: theme => theme.spacing(-1.5) },
            },
          },
        }}
      >
        {ids.map((id, i) =>{
          const database = data[id] as DatabaseResponseDto&RecPatch
          if (!database) { return null }
          return (
            <RecordContextProvider key={id} value={database}>
              <ListItem
                key={id}
                divider={true}
              > 
                <ListItemText>
                  <DatabaseNameField />
                  <ESCCatagoryHint />
                </ListItemText>
                <ListItemSecondaryAction>
                  <Tooltip title="View Change">
                    <IconButton 
                      edge="end" 
                      color="primary"
                      to={genUrlWithHashid('/databases/$0/encryption-setting-change', +id, database.name)}
                      component={RouteLink}
                    >
                      <Badge color="error" variant="dot" invisible={!database.encryptionKeyChanged && !database.fieldsChanged}>
                        <ArrowRightIcon fontSize="small" />
                      </Badge>
                    </IconButton>
                  </Tooltip>
                </ListItemSecondaryAction>
              </ListItem>
            </RecordContextProvider>
          )
        })}
      </List>
      {//@ts-ignore 
      <DefaultPagination {...listCtx} />}
    </Box>
  )
}

export default DbESCList;

const ESCCatagoryHint : FC = () => {
  const database = useRecordContext() as DatabaseResponseDto
  return (
    <Stack sx={{ ml: 'auto', mr: 4 }} spacing={2} direction="row">
      {database.encryptionKeyChanged &&
        <Chip label="Encryption Key" variant="outlined" color="secondary" size="small" />
      }
      {database.fieldsChanged &&
        <Chip label="Schema or Mapping" variant="outlined" color="secondary" size="small" />
      }
    </Stack>
  )
}
